<h1>New Voucher</h1>

<form [formGroup]="newVoucherForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="newVoucherForm.touched && newVoucherForm.invalid">
        <ul>
            <li *ngIf="newVoucherForm.touched && newVoucherForm.controls['dicountValue'].invalid">Dicount Value can't be empty.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="dicountValue">Discount Value</label>
        <input
            id="dicountValue"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="dicountValue"
            [ngClass]="{ 'input-validation-error': newVoucherForm.touched && newVoucherForm.controls['dicountValue'].invalid }"
            digitOnly
            [decimal]="true"
        />
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Create</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
